import { translate } from "../../../util/translate"

export const quoteTableHeaders = [
  {
    text: translate['quote.label.name'],
    value: 'item_name',
    width: 300,
  },
  {
    text: translate['quote.label.quantity'],
    value: 'service_report_item_quantity',
    align: 'center',
    width: 50,
  },
  {
    text: translate['quote.label.amount'],
    value: 'calculated_price',
    align: 'right',
    width: 150,
  },
  {
    text: '',
    align: 'center',
    value: 'data-table-expand',
    width: 50,
  },
]

export const quoteTableHeadersPrintable = [
  {
    text: translate['quote.label.name'],
    value: 'item_name'
  },
  {
    text: translate['quote.label.category'],
    value: 'item_category_name'
  },
  {
    text: translate['quote.label.itemDesc'],
    value: 'item_description'
  },
  {
    text: translate['quote.label.location'],
    value: 'service_report_item_location'
  },
  {
    text: translate['quote.label.serviceDesc'],
    value: 'service_report_item_description'
  },
  {
    text: translate['quote.label.qtd'],
    align: 'center',
    value: 'service_report_item_quantity'
  },
  {
    text: translate['quote.label.amount'],
    value: 'calculated_price'
  },
]
